import { NgModule } from "@angular/core";
import { LoadingComponent } from "./loading.component";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@NgModule({
  declarations: [LoadingComponent],
  exports: [LoadingComponent],
  imports: [MatProgressSpinner],
})
export class LoadingComponentModule {}
